import { Document } from './incident';

// Matches LOOKUP_ChatSenderType in the Maintenance database.
export enum ChatSenderType { Callcentre = 1, Fleet = 2, ServiceProvider = 3 }

export const chatSenderNames: Record<ChatSenderType, string> = {
  [ChatSenderType.Callcentre]: 'Callcentre',
  [ChatSenderType.Fleet]: 'Fleet',
  [ChatSenderType.ServiceProvider]: 'Service Provider'
};

export interface ChatMessage {
  chatMessageId: number;
  incidentId: number;
  chatSenderTypeId: ChatSenderType;
  message: string | null;
  createdDate: string;
  clientMessageId: string;
  senderPushSubscriptionId?: number | null;
  escalatedDate?: string | null;
  escalationAcknowledgedDate?: string | null;
  acknowledgedByUserId?: number | null;
  document: Document | null;
}

export interface ChatHistory { messages: ChatMessage[]; hasMore: boolean; }

export interface ChatEscalation {
  incidentId: number;
  chatMessageId: number;
  incidentNumber?: string | null;
  message?: string | null;
  escalatedDate: string;
  escalationAcknowledgedDate?: string | null;
  acknowledgedByUserId?: number | null;
}

export interface ChatEscalationResult extends ChatMessage { notificationError?: string | null; }

export interface ChatWhatsappResult { chatMessageId: number; queuedMessages: number; error: string | null; }

export interface IncidentChatMessageCreated { incidentId: number; chatMessageId: number; }

export interface ViewedChatMessage {
  incidentId: number;
  chatMessageId: number;
  viewerType: ChatSenderType;
  readDate: string;
}

export interface PendingChatMessage {
  clientMessageId: string;
  senderPushSubscriptionId?: number | null;
  incidentId: number;
  chatSenderTypeId: ChatSenderType;
  message: string;
  file?: Blob;
  filename?: string;
  durationSeconds?: number;
  createdDate: string;
  status: 'pending' | 'sending' | 'failed';
  error?: string;
}
